/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import { Stepper as VStepper, IconCheckmark, useDirection } from '@veneer/core';
import './styles.scss';
import { withAnalytics } from '@veneer/analytics';
import { StepperProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Stepper component based on Stepper of veneer
 * @public
 */
const TStepper: React.FC<StepperProps> = ({
  id = generateID('clientos-ui-toolkit-stepper'),
  direction,
  onChange,
  steps
}) => {
  const rtl = useDirection().isRTL;

  const vsteps = steps?.map(
    (
      {
        id = generateID('clientos-ui-toolkit-stepper-step'),
        status,
        title,
        description,
        state
      },
      index
    ) => {
      if (status === 'next' || status === undefined)
        status = 'incomplete' as any;
      else if (status === 'pending') status = 'disabled' as any;
      if (state === undefined) {
        if (status === 'complete') state = (<IconCheckmark size={16} />) as any;
        else state = index + 1;
      }
      return {
        status: status as any,
        label: (
          <>
            <div
              id={`${id}__label__step-title`}
              className={`clientos-ui-toolkit-stepper__label__step-title clientos-ui-toolkit-stepper__label__step-title--${status} body`}
            >
              {title}
            </div>
            <div
              id={`${id}__label__step-description`}
              className={`clientos-ui-toolkit-stepper__label__step-description clientos-ui-toolkit-stepper__label__step-description--${status} caption-large`}
            >
              {description}
            </div>
          </>
        ) as any,
        step: (
          <div
            id={`${id}__step-state`}
            className={`clientos-ui-toolkit-stepper__step-state clientos-ui-toolkit-stepper__step-state--${status}`}
          >
            {state}
          </div>
        )
      };
    }
  );

  return (
    <VStepper
      id={id}
      className={`clientos-ui-toolkit-stepper ${direction === 'vertical' ? 'clientos-ui-toolkit-stepper--vertical' : 'clientos-ui-toolkit-stepper--horizontal'} ${rtl ? 'rtl' : ''}`}
      direction={direction}
      onChange={onChange}
      steps={vsteps}
      interactive={true}
    />
  );
};
export const StepperAnalytics = withAnalytics(TStepper);
export default memo(TStepper);
